module.exports = __webpack_public_path__ + "img/smile.acaa1934.png";